interface Options {
    length: number
    required?: boolean
}

export const validateLength =
    ({ length, required }: Options) =>
    (_, value: string) => {
        if (!value) {
            return Promise.resolve()
        }

        const textContent = value.replace(/<[^>]+>/g, '')

        if (required && !textContent) {
            return Promise.reject(new Error(`Обязательное поле`))
        }

        if (textContent.length > length) {
            return Promise.reject(new Error(`Содержание не должно превышать ${length} символа`))
        }

        return Promise.resolve()
    }
